import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class IntermediateTimingPointModel extends Model 
{
	@attr name;
	@attr description;
	
	@belongsTo('event', {inverse: 'intermediateTimingPoints', async: true}) EventId;
}